import { useEffect, useRef, useState } from "react";

/**
 * Animate a numeric value from 0 → end over `duration` ms.
 * Uses requestAnimationFrame with ease-out-cubic.
 * Re-triggers whenever `end` changes.
 */
export function useCountUp(end, duration = 700) {
  const [value, setValue] = useState(0);
  const rafRef = useRef(null);

  useEffect(() => {
    if (typeof end !== "number" || Number.isNaN(end)) {
      setValue(end ?? 0);
      return;
    }
    const start = performance.now();
    const from = 0;
    const to = end;

    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3); // ease-out cubic
      setValue(from + (to - from) * eased);
      if (t < 1) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        setValue(to);
      }
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [end, duration]);

  return value;
}
